import {h} from 'preact';
import cx from 'classnames';
import Icon from '@components/common/Icon';
import ItemCountBadge from '../ItemCountBadge';
import {STORE_URL} from '@util/URLUtils';

const classList = {
    header: 'flex h-full justify-between items-center px-4 font-semibold text-center bg-grey-darkest absolute pin-t pin-r pin-l',
    divider: 'border-l border-solid border-grey',
    label: 'flex items-center h-full inline-block px-4 text-inherit hover:text-inherit',
    button: 'flex h-full items-center inline-block px-6 pr-8 font-semibold text-center relative'
};

const CartHeader = ( {cartItemCount}, {miniCartEnabled} ) => {
    const openIconAttributes = {};

    if ( miniCartEnabled ) {
        openIconAttributes.name = 'arrow-left-double';
        openIconAttributes['data-tooltip'] = 'Show';
    }

    const cartBtnClass = cx( classList.button, {
        'cursor-pointer': miniCartEnabled
    } );

    return (
        <li data-testid="cart-header" id="nav-item--cart"
            className="nav-item--cart flex items-center h-full relative text-white nowrap">

            <div data-testid="toggle-cart-action-btn" className={`nav-item--cart-button ${cartBtnClass}`}
                 data-action="toggle-cart">
                <svg className="absolute pin-t pin-l text-grey-light" width="11" height="100%" viewBox="0 0 11 45"
                     xmlns="http://www.w3.org/2000/svg">
                    <path fill="currentColor" d="M11.101 45.25l-.911.411L.038 23.111l10.4-24.414.92.392L1.13 23.1z"/>
                </svg>
                <span className="whitespace-no-wrap flex-shrink inline-block">
                    <Icon.ui name="shopping-cart" className="text-xl"/>
                    <ItemCountBadge className="fade-in" count={cartItemCount}/>
                </span>
                <Icon.ui data-testid="minicart-open-action-icon"
                         {...openIconAttributes}
                         className="fade-in ml-4 text-lg min-h-full"/>
            </div>
            <div className={`nav-item--cart-header ${classList.header} ${classList.divider}`}>
                <span className="w-6 whitespace-no-wrap flex-shrink inline-block">
                    <Icon.ui name="shopping-cart" className="text-xl"/>
                    <ItemCountBadge className="fade-in" count={cartItemCount}/>
                </span>
                <a href={STORE_URL} className="nav-item--cart-label">Cart Summary</a>
                <Icon.ui data-action="toggle-cart"
                         data-tooltip="Hide"
                         id="minicart-close-action-icon"
                         name="arrow-right-double"
                         className="mr-2 text-lg cursor-pointer"/>
            </div>
        </li>
    );
};

export default CartHeader;
